import { updateItems } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '新片上线': 'bg-primary-100 text-primary-700',
  '专题活动': 'bg-accent-100 text-accent-700',
  '功能升级': 'bg-secondary-100 text-secondary-700',
  '剧集更新': 'bg-primary-100 text-primary-700',
  '内容扩充': 'bg-accent-100 text-accent-700',
  '体验优化': 'bg-secondary-100 text-secondary-700',
  '新频道': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            影讯快报
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            最新影片上线与平台动态一手掌握
          </p>
        </div>

        <div className="relative pl-8 border-l-2 border-primary-200 space-y-6">
          {updateItems.map((item, index) => (
            <div key={item.id} className="relative">
              <div className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span
                  className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    tagColors[item.tag] || 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 flex-1">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  {item.date}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}